import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
// import Location so that I can query the current path
import { Location } from '@angular/common';
// import Router so that I can subscribe to events
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromRoot from '../../../reducers';

@Component({
    selector: 'app-prompts',
    templateUrl: './olci-prompts.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OlciPromptsComponent {
	// attributes to control the activation
	@Input() public bundle: any;

	public layoutState$: Observable<any>;
	screensize$: Observable<any>;

	constructor(private readonly location: Location, private readonly store: Store<fromRoot.AppState>) {
		this.layoutState$ = this.store.pipe(select(fromRoot.getLayoutState));
		this.screensize$ = this.store.pipe(select(fromRoot.getContentScreenSize));
	}
}
